import React, { useState, useEffect } from "react";
import {
  Divider,
  Icon,
  Table,
  Button,
} from "semantic-ui-react";
import { LoadingSpinner } from "../../../Shared";
import searchSvg from "../../../../assets/svg/search.svg";
import "./ListSites.scss";
import { size, map } from "lodash";
import { Permission, Site } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { SiteItem } from "../SiteItem";
import {
  hasPermission,
  isAdmin,
  isMaster,
} from "../../../../utils/checkPermission";
import { ErrorAccessDenied } from "../../../../pages/admin/Error";
import { useLanguage } from "../../../../contexts";
import { BasicModal } from "../../../Shared";
import { SiteForm } from "../SiteForm";
const _ = require("lodash");

const siteController = new Site();
const permissionController = new Permission();

export function ListSites(props) {
  const { sitesActive, reload, onReload, companySelected, role } = props;
  const [sites, setSites] = useState(null);
  const [sitesFilter, setSitesFilter] = useState([]);
  const [permissionByRole, setPermissionsByRole] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const onOpenCloseModal = () => setShowModal((prev) => !prev);

  const { accessToken, user: { site: assignedSite } } = useAuth();
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  // 🔹 Cargar permisos
  useEffect(() => {
    (async () => {
      try {
        if (role) {
          const response = await permissionController.getMyPermissions(accessToken, true);
          setPermissionsByRole(response);
        }
      } catch (error) {
        console.error(error);
        setPermissionsByRole([]);
      }
    })();
  }, [role]);

  // 🔹 Cargar sitios
  useEffect(() => {
    (async () => {
      try {
        setSites(null);
        setSitesFilter([]);
        let response = [];
        if (!companySelected) {
          response = await siteController.getSites(accessToken, sitesActive);
        } else {
          response = await siteController.getSitesByCompany(
            accessToken,
            companySelected,
            sitesActive
          );
        }
        let result = response.map((s) => ({ ...s, key: s._id }));
        if (isAdmin(role) && assignedSite) {
          result = result.filter((s) => s._id === assignedSite);
        }
        setSites(result);
        setSitesFilter(result);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [sitesActive, reload, accessToken, companySelected]);

  if (!sites) return <LoadingSpinner />;

  return (
    <div className="sites-list">
      {(isMaster(role) ||
        isAdmin(role) ||
        hasPermission(permissionByRole, role._id, "sites", "view")) ? (
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "1rem" }}>
            <SearchStandardSite
              dataOrigin={sites}
              data={sitesFilter}
              setData={setSitesFilter}
              t={t}
            />
            {!(isAdmin(role) && assignedSite) &&
              (isMaster(role) ||
              isAdmin(role) ||
              hasPermission(permissionByRole, role._id, "sites", "create")) &&
              companySelected && (
                <Button icon className="add-site-btn" onClick={() => setShowModal(true)}>
                  <Icon name="plus" />
                </Button>
              )}
          </div>

          <Divider clearing />

          {sites.length === 0 ? (
            <div style={{ textAlign: "center", marginTop: "2rem" }}>
              {t("there_is_no_site")}
            </div>
          ) : (
            <Table className="sites-table">
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>{t("company_name")}</Table.HeaderCell>
                  <Table.HeaderCell>{t("cuit")}</Table.HeaderCell>
                  <Table.HeaderCell>{t("phone")}</Table.HeaderCell>
                  <Table.HeaderCell>{t("email")}</Table.HeaderCell>
                  <Table.HeaderCell>{t("actions")}</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {map(sitesFilter, (site) => (
                  <SiteItem key={site._id} site={site} onReload={onReload} permissionsByRole={permissionByRole} />
                ))}
              </Table.Body>
            </Table>
          )}

          <BasicModal
            show={showModal}
            close={onOpenCloseModal}
            title={null}
            size="small"
          >
            <SiteForm
              close={onOpenCloseModal}
              onReload={onReload}
              company={companySelected}
            />
          </BasicModal>
        </div>
      ) : (
        <ErrorAccessDenied />
      )}
    </div>
  );
}


function SearchStandardSite(props) {
  const { dataOrigin, data, setData, t } = props;
  const [state, setState] = useState({
    isLoading: false,
    results: [],
    value: "",
  });

  const [filter, setFilter] = useState("name");

  const handleChange = (e, { name, value }) => {
    setFilter(value);
    setData(dataOrigin);
    setState({ value: "" });
  };

  const handleSearchChange = (e, { value }) => {
    setState({ isLoading: true, value });

    setTimeout(() => {
      if (value && value.length < 1) {
        setState({ isLoading: false, results: [], value: "" });
        setData(dataOrigin);
        return true;
      } else if (value.length === 0) {
        setData(dataOrigin);
        setState({ isLoading: false, results: [], value: "" });
        return true;
      }
      // const re = new RegExp(_.escapeRegExp(value), "i");
      // const isMatch = (result) => re.test(result[filter]);
      const filteredData = dataOrigin.filter((item) =>
        Object.values(item).some((v) =>
          v.toString().toLowerCase().includes(value.toLowerCase())
        )
      );
      setState({
        isLoading: false,
        // results: _.filter(data, isMatch),
        results: filteredData,
      });
      setData(filteredData);
    }, 300);
  };

  const options = [
    {
      key: 1,
      text: "Nombre",
      value: "name",
    },
    {
      key: 2,
      text: "CUIT",
      value: "cuit",
    },
    {
      key: 3,
      text: "Email",
      value: "email",
    },
  ];

  return (
    <div className="search-user-wrapper">
      <img src={searchSvg} alt="search" className="search-user-icon" />
      <input
        className="search-user-input"
        placeholder={t("search")}
        onChange={_.debounce((e) => handleSearchChange(e, { value: e.target.value }), 500, { leading: true })}
      />
    </div>
  );
}

const EditableTable = () => {
  const [data, setData] = useState([
    { id: 1, name: "John Doe", age: 30 },
    { id: 2, name: "Jane Smith", age: 25 },
    // Add more initial data as needed
  ]);

  const handleEdit = (id, field, value) => {
    const newData = data.map((item) => {
      if (item.id === id) {
        return { ...item, [field]: value };
      }
      return item;
    });
    setData(newData);
  };

  return (
    <Table celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Name</Table.HeaderCell>
          <Table.HeaderCell>Age</Table.HeaderCell>
          <Table.HeaderCell>Action</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {data.map((item) => (
          <Table.Row key={item.id}>
            <Table.Cell>
              <input
                type="text"
                value={item.name}
                onChange={(e) => handleEdit(item.id, "name", e.target.value)}
              />
            </Table.Cell>
            <Table.Cell>
              <input
                type="number"
                value={item.age}
                onChange={(e) => handleEdit(item.id, "age", e.target.value)}
              />
            </Table.Cell>
            <Table.Cell>
              <Button color="red">Delete</Button>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

const EditableTable2 = () => {
  const [data, setData] = useState([
    { id: 1, name: "John Doe", age: 30, gender: "Male" },
    { id: 2, name: "Jane Smith", age: 25, gender: "Female" },
    // Add more initial data as needed
  ]);

  const genders = [
    { key: "male", text: "Male", value: "Male" },
    { key: "female", text: "Female", value: "Female" },
  ];

  const handleEdit = (id, field, value) => {
    const newData = data.map((item) => {
      if (item.id === id) {
        return { ...item, [field]: value };
      }
      return item;
    });
    setData(newData);
  };

  return (
    <Table celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Name</Table.HeaderCell>
          <Table.HeaderCell>Age</Table.HeaderCell>
          <Table.HeaderCell>Gender</Table.HeaderCell>
          <Table.HeaderCell>Action</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {data.map((item) => (
          <Table.Row key={item.id}>
            <Table.Cell>
              <input
                type="text"
                value={item.name}
                onChange={(e) => handleEdit(item.id, "name", e.target.value)}
              />
            </Table.Cell>
            <Table.Cell>
              <input
                type="number"
                value={item.age}
                onChange={(e) => handleEdit(item.id, "age", e.target.value)}
              />
            </Table.Cell>
            <Table.Cell>
              <Dropdown
                selection
                options={genders}
                value={item.gender}
                onChange={(e, { value }) =>
                  handleEdit(item.id, "gender", value)
                }
              />
            </Table.Cell>
            <Table.Cell>
              <Button color="red">Delete</Button>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};
